import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';

import { BaseComponent } from 'src/app/components/base/base.component';
import { EnvironmentService } from 'src/app/services/environment.service';
import { AuthService } from '../../services/auth.service';


@Component({
  templateUrl: './logout-callback.component.html',
  styleUrls: [
    './../../../../../styles.scss',
    './logout-callback.component.scss'
  ],
  encapsulation: ViewEncapsulation.ShadowDom
})
export class LogoutCallbackComponent extends BaseComponent implements OnInit, OnChanges {
  /** 
   * FOR DEVELOPMENT/TESTING PURPOSES
   * false (default) - redirect to a page that was before loging in; 
   * true - stay on login callback page
   */
  @Input() dontRedirectToInitPage: boolean = false;

  constructor(
    private authService: AuthService,
    protected override environmentService: EnvironmentService
  ) {
    super(environmentService);
  }

  async ngOnInit() {
    if (!this.dontRedirectToInitPage) {
      this.authService.navigateToInitialPage();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customEnvironment']) {
      this.defineEnvironment();
    }
  }
}
